<template>
  <div class="depositSubscriptionCard">
    <div class="depositSubscriptionCard__topRight">
      <img src="@/assets/soderberg.png" />
    </div>
    <div class="depositSubscriptionCard__content">
      <h4 class="mt-2 text-break">Depositumsgaranti</h4>

      <hr class="depositSubscriptionCard__content__horizLine" />

      <div class="depositSubscriptionCard__content__grid mt-4">
        <div class="depositSubscriptionCard__content__grid__left">
          <div v-for="(item, index) in items" :key="index" class="depositSubscriptionCard__content__grid__left__item">
            <span>
              <i :class="item.icon" />
            </span>
            <div>
              <span>{{ item.title }}: </span>
              <strong
                :class="{ depositSubscriptionCard__content__grid__left__item__letterSpacing: item.letterSpacing }"
              >
                {{ item.value }}
              </strong>
            </div>
          </div>
          <hr />
        </div>
        <div class="depositSubscriptionCard__content__grid__right">
          <template v-if="policyLink">
            <div></div>
            <div class="depositSubscriptionCard__content__grid__right__document">
              <div>
                <strong>{{ translationPolicyDocument }}</strong>
                <a :href="policyLink">
                  <i class="budicon-document-page" />
                </a>
                <hr />
              </div>
            </div>
          </template>
          <div v-if="shouldShowButtons" class="depositSubscriptionCard__content__grid__right__buttonsMobile">
            <button class="btn btn-primary" @click="$emit('buttonClickTermination')">
              {{ button1Text }}
            </button>
            <button class="depositSubscriptionCard__content__buttonDemand" @click="$emit('buttonClickDemand')">
              {{ button2Text }}
            </button>
          </div>
        </div>
      </div>
      <div v-if="shouldShowButtons" class="depositSubscriptionCard__content__buttonsDesktop">
        <button class="btn btn-primary" @click="$emit('buttonClickTermination')">
          {{ button1Text }}
        </button>
        <button class="depositSubscriptionCard__content__buttonDemand" @click="$emit('buttonClickDemand')">
          {{ button2Text }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import RenderHTML from '@modules/design-system/components/atoms/RenderHTML.vue';

export default Vue.extend({
  name: 'DepositSubscriptionCard',
  props: {
    items: {
      type: Array,
      required: true,
    },
    button1Text: {
      type: String,
      required: true,
    },
    button2Text: {
      type: String,
      required: true,
    },
    translationPolicyDocument: {
      type: String,
      required: false,
    },
    policyLink: {
      type: String,
      required: true,
    },
    shouldShowButtons: {
      type: Boolean,
      required: true,
    },
  },
  components: {
    'a-RenderHTML': RenderHTML,
  },
});
</script>

<style lang="scss" scoped>
.depositSubscriptionCard {
  position: relative;
  padding: 1rem;
  background: white;
  border: 1px solid $husleie-light-grey;
}
.depositSubscriptionCard__topRight {
  display: none;
}
.depositSubscriptionCard__content {
  padding: 0rem 1rem;
  margin-top: 2rem;
}
.depositSubscriptionCard__content__grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 0.5rem 1rem;
}
.depositSubscriptionCard__content__grid__left {
  display: grid;
  grid-template-columns: 1fr;
  gap: 0.8rem 0rem;
}
.depositSubscriptionCard__content__grid__left hr {
  display: relative;
  width: 100%;
}
.depositSubscriptionCard__content__grid__left__item {
  display: flex;
  align-items: center;
  gap: 0rem 1rem;
}
.depositSubscriptionCard__content__grid__left__item__letterSpacing {
  letter-spacing: 1.5px;
}
.depositSubscriptionCard__content__grid__left__item i {
  font-size: 1.5rem;
}
.depositSubscriptionCard__content__grid__right {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem 0rem;
}
.depositSubscriptionCard__content__grid__right__document div {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem 0rem;
}
.depositSubscriptionCard__content__grid__right__document div hr {
  margin-top: 0.5rem;
  width: 100%;
}
.depositSubscriptionCard__content__grid__right__document a {
  color: black;
}
.depositSubscriptionCard__content__grid__right__document i {
  font-size: 1.8rem;
  cursor: pointer;
}
.depositSubscriptionCard__content__grid__right__buttonsMobile {
  display: flex;
  flex-direction: column;
  gap: 1rem 0rem;
}
.depositSubscriptionCard__content__buttonsDesktop {
  display: none;
}

.depositSubscriptionCard__content button {
  border-radius: $border-radius-medium;
}
.depositSubscriptionCard__content__buttonDemand {
  display: initial;
  background: white;
  border: 1px solid #0a1f44;
  color: #0a1f44;
  padding: 0.7rem 1rem;
}
.depositSubscriptionCard__content__buttonDemand:hover {
  background: #54627c;
  border: 1px solid #54627c;
  color: white;
}

@media (min-width: 1160px) {
  .depositSubscriptionCard__content__buttonMobile {
    display: none;
  }
  .depositSubscriptionCard {
    position: relative;
    padding: 1rem;
    background: white;
    border: 1px solid $husleie-light-grey;
  }
  .depositSubscriptionCard__topRight {
    display: flex;
    justify-content: flex-end;
  }
  .depositSubscriptionCard__topRight img {
    width: 100px;
    height: 32px;
  }
  .depositSubscriptionCard__content {
    padding: 0rem 3rem 2rem 3rem;
    margin-top: 0;
  }
  .depositSubscriptionCard__content__horizLine {
    display: block;
    margin: 0.2rem 0 0 0.2rem;
    width: 70%;
  }
  .depositSubscriptionCard__content__grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    gap: 0rem 2rem;
  }
  .depositSubscriptionCard__content__grid__left {
    display: grid;
    grid-template-columns: 1fr;
    grid-auto-rows: max-content;
    gap: 0.8rem 0rem;
  }
  .depositSubscriptionCard__content__grid__left hr {
    display: none;
  }
  .depositSubscriptionCard__content__grid__right {
    display: grid;
    grid-template-columns: max-content 1fr;
    align-items: flex-start;
    gap: 2rem 1rem;
  }
  .depositSubscriptionCard__content__grid__right__document {
    display: flex;
    justify-content: flex-end;
    margin: 1rem 1.2rem 0rem 0rem;
  }
  .depositSubscriptionCard__content__grid__right__buttonsMobile {
    display: none;
  }
  .depositSubscriptionCard__content__buttonsDesktop {
    display: flex;
    justify-content: flex-end;
    gap: 0rem 1rem;
    margin-top: 1.5rem;
  }
}
</style>
